export default function Skills() {
  const skillCategories = [
    {
      title: 'Design',
      icon: 'ri-palette-line',
      color: 'teal',
      skills: [
        { name: 'UI/UX Design', level: 95 },
        { name: 'Figma', level: 90 },
        { name: 'Adobe XD', level: 85 },
        { name: 'Photoshop', level: 88 }
      ]
    },
    {
      title: 'Development',
      icon: 'ri-code-line',
      color: 'blue',
      skills: [
        { name: 'React', level: 92 },
        { name: 'TypeScript', level: 88 },
        { name: 'Node.js', level: 85 },
        { name: 'Tailwind CSS', level: 95 }
      ]
    },
    {
      title: 'Tools',
      icon: 'ri-tools-line',
      color: 'purple',
      skills: [
        { name: 'Git', level: 90 },
        { name: 'VS Code', level: 95 },
        { name: 'Webpack', level: 80 },
        { name: 'Docker', level: 75 }
      ]
    }
  ];

  const getColorClasses = (color: string) => {
    const colors: Record<string, { bg: string; text: string; gradient: string }> = {
      teal: { bg: 'bg-teal-50', text: 'text-teal-600', gradient: 'from-teal-500 to-teal-600' },
      blue: { bg: 'bg-blue-50', text: 'text-blue-600', gradient: 'from-blue-500 to-blue-600' },
      purple: { bg: 'bg-purple-50', text: 'text-purple-600', gradient: 'from-purple-500 to-purple-600' }
    };
    return colors[color];
  };

  return (
    <section id="skills" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="px-4 py-2 bg-teal-50 text-teal-600 rounded-full text-sm font-semibold">
              My Skills
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What I Bring to the Table
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A diverse skill set combining creative design with technical expertise to deliver exceptional results
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {skillCategories.map((category, index) => {
            const colors = getColorClasses(category.color);
            return (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className={`w-16 h-16 flex items-center justify-center ${colors.bg} rounded-xl mb-6`}>
                  <i className={`${category.icon} text-3xl ${colors.text}`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">{category.title}</h3>
                <div className="space-y-5">
                  {category.skills.map((skill, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between mb-2">
                        <span className="font-semibold text-gray-700">{skill.name}</span>
                        <span className={`font-bold ${colors.text}`}>{skill.level}%</span>
                      </div>
                      <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                        <div 
                          className={`h-full bg-gradient-to-r ${colors.gradient} rounded-full transition-all duration-1000`}
                          style={{ width: `${skill.level}%` }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="bg-gradient-to-r from-teal-500 to-blue-600 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Always Learning, Always Growing</h3>
          <p className="text-xl mb-8 opacity-90">
            Technology evolves rapidly, and so do I. Committed to staying at the forefront of design and development trends.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <div className="px-6 py-3 bg-white/20 backdrop-blur-sm rounded-full font-semibold">
              Web3 Development
            </div>
            <div className="px-6 py-3 bg-white/20 backdrop-blur-sm rounded-full font-semibold">
              AI Integration
            </div>
            <div className="px-6 py-3 bg-white/20 backdrop-blur-sm rounded-full font-semibold">
              Mobile Development
            </div>
            <div className="px-6 py-3 bg-white/20 backdrop-blur-sm rounded-full font-semibold">
              Cloud Architecture
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
